module.exports = __webpack_public_path__ + "static/media/icn-comment-not-resolved.7e303350.svg";